import { render, staticRenderFns } from "./sidemenu_tiktok.vue?vue&type=template&id=7faa7a70&scoped=true&"
import script from "./sidemenu_tiktok.vue?vue&type=script&lang=js&"
export * from "./sidemenu_tiktok.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu_tiktok.vue?vue&type=style&index=0&id=7faa7a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa7a70",
  null
  
)

export default component.exports